import React, { useState, useRef, useImperativeHandle } from 'react';
import { Search } from 'styled-icons/material/Search';
import { InputText } from '../../Input';
import * as Ui from './styles';

function InputSearch({
  placeholder = 'Pesquisar...',
  required = false,
  disabled = false,
  styleClass = '',
  onChangeText,
  background,
  // Define o valor inicial para o input
  textValue = '',
}, ref) {
  // states
  const [text, setText] = useState(textValue);
  // refs
  const inputTextRef = useRef();

  // handle filter change
  function handleFilter(value) {
    // modifica o estado
    setText(value);
    // notifica ouvintes
    if (onChangeText) onChangeText(value);
  }

  useImperativeHandle(ref, () => ({
    clear: () => {
      setText('');
      if (inputTextRef.current) {
        inputTextRef.current.clear();
      }
    },
  }));

  return (
    <Ui.Container
      className={disabled ? `${styleClass} disabled` : `${styleClass}`}
      background={background}
    >
      <InputText
        ref={inputTextRef}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        value={text}
        onChange={(value) => handleFilter(value)}
      />
      <Search className="icon" size={25} />
    </Ui.Container>
  );
}

export default React.forwardRef(InputSearch);
